<div>
  <nb-card class="nb-card-mobile-rs">
    <nb-card-body [formGroup]="PatientForm" [nbSpinner]="isLoading">
      <div class="row">
        <div class="col-lg-6">
          <nb-card>
            <nb-card-header>
              <div i18n="@@GeneralInfo" class="subtitle">Contact Info</div>
            </nb-card-header>
            <nb-card-body>
              <input formControlName="Id" type="hidden" />

              <div class="form-group row">
                <div i18n="@@Name" class="col-sm-4 label col-form-label">
                  Name
                </div>
                <div class="col-sm-8">
                  <input
                    nbInput
                    formControlName="FirstName"
                    [readonly]="IsView"
                    [status]="
                      FirstName?.errors?.required ||
                      FirstName?.hasError('minlength') ||
                      FirstName?.hasError('maxlength')
                        ? 'danger'
                        : 'primary'
                    "
                    type="text"
                    fullWidth
                    shape="semi-round"
                    i18n-placeholder="@@Name"
                    placeholder="Name"
                  />
                  <ngx-validation-message
                    i18n-label="@@Name"
                    label="Name"
                    [showMinLength]="FirstName?.hasError('minlength')"
                    [showMaxLength]="FirstName?.hasError('maxlength')"
                    [showRequired]="
                      FirstName?.errors?.required && FirstName.touched
                    "
                    minLength="3"
                    maxLength="50"
                  ></ngx-validation-message>
                </div>
              </div>
              <div class="form-group row">
                <div i18n="@@LastName" class="col-sm-4 label col-form-label">
                  Last Name
                </div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    formControlName="LastName"
                    [readonly]="IsView"
                    [status]="
                      LastName?.errors?.required ||
                      LastName?.hasError('minlength') ||
                      LastName?.hasError('maxlength')
                        ? 'danger'
                        : 'primary'
                    "
                    nbInput
                    fullWidth
                    shape="semi-round"
                    i18n-placeholder="@@LastName"
                    placeholder="Last Name"
                  />
                  <ngx-validation-message
                    i18n-label="@@LastName"
                    label="Last Name"
                    [showMinLength]="LastName?.hasError('minlength')"
                    [showMaxLength]="LastName?.hasError('maxlength')"
                    [showRequired]="
                      LastName?.errors?.required && LastName.touched
                    "
                    minLength="3"
                    maxLength="50"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div
                  i18n="@@EmailAddress"
                  class="col-sm-4 label col-form-label"
                >
                  Email Address
                </div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    nbInput
                    fullWidth
                    shape="semi-round"
                    [status]="
                      EMail?.errors?.required ||
                      EMail?.hasError('minlength') ||
                      EMail?.hasError('maxlength') ||
                      EMail?.hasError('pattern')
                        ? 'danger'
                        : 'primary'
                    "
                    [readonly]="IsView"
                    formControlName="EMail"
                    i18n-placeholder="@@EmailAddress"
                    placeholder="Email Address"
                  />
                  <ngx-validation-message
                    i18n-label="@@EmailAddress"
                    label="Email Address"
                    [showPattern]="EMail?.hasError('pattern') && EMail.touched"
                    [showRequired]="EMail?.errors?.required && EMail.touched"
                    min="1"
                    max="120"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@PhoneNumber" class="col-sm-3 label col-form-label">
                  Mobile Number
                </div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <ngx-intl-tel-input
                    [preferredCountries]="preferredCountries"
                    [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="true"
                    [searchCountryField]="[
                      SearchCountryField.Iso2,
                      SearchCountryField.Name
                    ]"
                    [selectFirstCountry]="false"
                    [selectedCountryISO]="CountryISO.UnitedStates"
                    [maxLength]="15"
                    [numberFormat]="PhoneNumberFormat.International"
                    [phoneValidation]="true"
                    name="PhoneNumber"
                    formControlName="PhoneNumber"
                    shape="semi-round"
                  ></ngx-intl-tel-input>
                  <ngx-validation-message
                    i18n-label="@@PhoneNumber"
                    label="Mobile Number"
                    [showPattern]="PhoneNumber?.invalid"
                    min="10"
                    max="15"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@DateOfBirth" class="col-sm-4 label col-form-label">
                  Date of Birth
                </div>
                <div class="col-sm-8">
                  <ng-container *ngIf="!IsView">
                    <input
                      nbInput
                      i18n-placeholder="@@DateOfBirth"
                      [status]="
                        DateOfBirth?.errors?.required ? 'danger' : 'basic'
                      "
                      fullWidth
                      shape="semi-round"
                      [nbDatepicker]="formpicker"
                      formControlName="DateOfBirth"
                    />
                    <nb-datepicker #formpicker></nb-datepicker>
                  </ng-container>
                  <ng-container *ngIf="IsView">
                    <input
                      nbInput
                      i18n-placeholder="@@DateOfBirth"
                      readonly
                      fullWidth
                      shape="semi-round"
                      [value]="DateOfBirth.value | date: 'MMM dd, yyyy'"
                    />
                  </ng-container>
                  <ngx-validation-message
                    i18n-label="@@DateOfBirth"
                    label="Date of Birth"
                    [showRequired]="
                      DateOfBirth?.errors?.required && DateOfBirth.touched
                    "
                  ></ngx-validation-message>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>

        <div class="col-lg-6">
          <nb-card>
            <nb-card-header>
              <div i18n="@@Address" class="subtitle">Address</div>
            </nb-card-header>

            <nb-card-body>
              <div class="form-group row">
                <div i18n="@@Address" class="col-sm-4 label col-form-label">
                  Address
                </div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    nbInput
                    fullWidth
                    shape="semi-round"
                    [readonly]="IsView"
                    formControlName="AddressLine1"
                    i18n-placeholder="@@AddressLine1"
                    placeholder="Line 1"
                  />
                  <ngx-validation-message
                    i18n-label="@@AddressLine1"
                    [showMaxLength]="AddressLine1?.hasError('maxlength')"
                    minLength="3"
                    maxLength="1024"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-4 label col-form-label"></div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    nbInput
                    fullWidth
                    shape="semi-round"
                    [readonly]="IsView"
                    formControlName="AddressLine2"
                    i18n-placeholder="@@AddressLine2"
                    placeholder="Line 2"
                  />
                  <ngx-validation-message
                    i18n-label="@@AddressLine2"
                    label="Line 2"
                    [showMaxLength]="AddressLine2?.hasError('maxlength')"
                    minLength="3"
                    maxLength="1024"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@Country" class="col-sm-4 label col-form-label">
                  Country
                </div>
                <div class="col-sm-8">
                  <ng-container *ngIf="IsView">
                    <input
                      type="text"
                      nbInput
                      fullWidth
                      shape="semi-round"
                      readonly
                      [value]="Country.value"
                    />
                  </ng-container>
                  <ng-container *ngIf="!IsView">
                    <nb-select
                      id="Country"
                      size="medium"
                      i18n-placeholder="@@Country"
                      placeholder="{{ CountryInfoLabel }}"
                      fullWidth
                      [status]="
                        Country?.errors?.required && Country.touched
                          ? 'danger'
                          : 'primary'
                      "
                      formControlName="Country"
                    >
                      <nb-option
                        *ngFor="let item of Countries | async"
                        [value]="item.name"
                        >{{ item.name }}</nb-option
                      >
                    </nb-select>
                  </ng-container>
                  <ngx-validation-message
                    i18n-label="@@Country"
                    label="Country"
                    [showMaxLength]="Country?.hasError('maxlength')"
                    minLength="3"
                    maxLength="1024"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@PostalCode" class="col-sm-4 label col-form-label">
                  Zip / Postal Code
                </div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    nbInput
                    fullWidth
                    shape="semi-round"
                    [readonly]="IsView"
                    formControlName="ZipPostalCode"
                    i18n-placeholder="@@PostalCode"
                    placeholder="Zip / Postal Code"
                  />
                  <ngx-validation-message
                    i18n-label="@@PostalCode"
                    label="{{ PostalCodeInfoLabel }}"
                    [showMaxLength]="ZipPostalCode?.hasError('maxlength')"
                    minLength="3"
                    maxLength="25"
                  ></ngx-validation-message>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <nb-card>
            <nb-card-header>
              <div i18n="@@BiometricInfo" class="subtitle">BioMetric Info</div>
            </nb-card-header>

            <nb-card-body>
              <div class="form-group row">
                <div i18n="@@Height" class="col-sm-4 label col-form-label">
                  Height
                </div>
                <div class="col-sm-8">
                  <feet-and-inch
                    formControlName="Height"
                    [status]="Height?.errors?.required ? 'danger' : 'primary'"
                    [IsView]="IsView"
                    [isImperial]="IsPreferredUnitImperial.value"
                  ></feet-and-inch>
                  <ngx-validation-message
                    i18n-label="@@Height"
                    label="Height"
                    [showRequired]="Height?.errors?.required && Height.touched"
                    [showMaxLength]="Height?.hasError('maxlength')"
                    minLength="3"
                    maxLength="15"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@Weight" class="col-sm-4 label col-form-label">
                  Weight
                </div>
                <div class="col-sm-8">
                  <pounds-and-kg
                    formControlName="Weight"
                    [status]="Weight?.errors?.required ? 'danger' : 'primary'"
                    [IsView]="IsView"
                    [isImperial]="IsPreferredUnitImperial.value"
                    [IgnoreUpdate]="false"
                  ></pounds-and-kg>
                  <ngx-validation-message
                    i18n-label="@@Weight"
                    label="Weight"
                    [showRequired]="Weight?.errors?.required && Weight.touched"
                    [showMaxLength]="Weight?.hasError('maxlength')"
                    minLength="3"
                    maxLength="15"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@BMI" class="col-sm-4 label col-form-label">
                  BMI
                </div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    nbInput
                    shape="semi-round"
                    readonly
                    value="{{ BMI }}"
                    i18n-placeholder="@@BMI"
                    placeholder="BMI"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div
                  i18n="@@BodyFatPercent"
                  class="col-sm-4 label col-form-label"
                >
                  Body Fat %
                </div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    nbInput
                    shape="semi-round"
                    [readonly]="IsView"
                    formControlName="BodyFat"
                    (keypress)="validateNumber($event)"
                    i18n-placeholder="@@BodyFatPercent"
                    placeholder="Body Fat %"
                  />
                  <ngx-validation-message
                    i18n-label="@@BodyFatPercent"
                    label="Body Fat %"
                    [showMin]="BodyFat?.errors?.min && BodyFat.touched"
                    [showMax]="BodyFat?.errors?.max && BodyFat.touched"
                    [showRequired]="
                      BodyFat?.errors?.required && BodyFat.touched
                    "
                    [showPattern]="BodyFat?.hasError('pattern')"
                    min="0"
                    max="100"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row" *ngIf="false" style="display: none">
                <div
                  i18n="@@DateOfMeasure"
                  class="col-sm-4 label col-form-label"
                >
                  Date of Measure
                </div>
                <div class="col-sm-8">
                  <ng-container *ngIf="IsView">
                    <input
                      nbInput
                      shape="semi-round"
                      readonly
                      [value]="DateOfMeasure.value | date: 'MMM dd, yyyy hh:mm'"
                      i18n-placeholder="@@DateOfMeasure"
                      placeholder="{{ MeasureDateLabel }}"
                    />
                  </ng-container>
                  <ng-container *ngIf="!IsView">
                    <input
                      [owlDateTime]="dt1"
                      nbInput
                      shape="semi-round"
                      [owlDateTimeTrigger]="dt1"
                      i18n-placeholder="@@DateOfMeasure"
                      placeholder="{{ MeasureDateLabel }}"
                      formControlName="DateOfMeasure"
                    />
                    <owl-date-time #dt1></owl-date-time>
                  </ng-container>
                  <ngx-validation-message
                    i18n-label="@@DateOfMeasure"
                    label="Date of Measure"
                    [showRequired]="
                      DateOfMeasure?.errors?.required && DateOfMeasure.touched
                    "
                  ></ngx-validation-message>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>

        <div class="col-lg-6">
          <nb-card>
            <nb-card-header>
              <div i18n="@@Preferences" class="subtitle">Preferences</div>
            </nb-card-header>

            <nb-card-body>
              <div class="form-group row">
                <div i18n="@@Gender" class="col-sm-4 label col-form-label">
                  Gender
                </div>
                <div class="col-sm-8">
                  <nb-radio-group
                    formControlName="genderFemale"
                    name="genderFemale"
                    class="gender"
                  >
                    <nb-radio i18n="@@Male" [value]="false">Male</nb-radio>
                    <nb-radio i18n="@@Female" [value]="true">Female</nb-radio>
                  </nb-radio-group>
                </div>
              </div>

              <div class="form-group row">
                <div
                  i18n="@@PreferredUnits"
                  class="col-sm-4 label col-form-label"
                >
                  Preferred Units
                </div>
                <div class="col-sm-8">
                  <div style="display: flex">
                    <nb-radio-group
                      formControlName="IsPreferredUnitImperial"
                      name="IsPreferredUnitImperial"
                      (click)="ChangeScale($event)"
                    >
                      <nb-radio i18n="@@Metrics" [value]="false"
                        >Metrics</nb-radio
                      >
                      <nb-radio i18n="@@Imperial" [value]="true"
                        >Imperial</nb-radio
                      >
                    </nb-radio-group>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="conversionFactorsPreference"
                  class="col-sm-4 col-form-label"
                  >Conversion factor preference</label
                >
                <div class="col-sm-8">
                  <nb-select
                    id="conversionFactorsPreference"
                    size="medium"

                    placeholder="Conversion Factor Preference"
                    fullWidth
                    formControlName="conversionFactorPreference"
                  >
                    <nb-option
                      *ngFor="let item of ConversionFactorsPreference"
                      [value]="item.value"
                      >{{ item.text }}</nb-option
                    >
                  </nb-select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-4 label col-form-label">
                    Check In Request
                  </div>
                  <div class="col-sm-8">
                    <div style="display: flex">
                      <nb-radio-group
                        formControlName="checkInRequest"
                        name="checkInRequest"
                      >
                        <nb-radio [value]="true"
                          >Send Check In Requests</nb-radio
                        >
                        <nb-radio [value]="false"
                          >Don't send Check In Requests</nb-radio
                        >
                      </nb-radio-group>
                    </div>
                  </div>
                </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-lg-6">
          <nb-card>
            <nb-card-header>
              <div class="subtitle">Subscription</div>
            </nb-card-header>

            <nb-card-body>
              <div class="form-group row">
                <div i18n="@@Height" class="col-sm-3 label col-form-label">Select Subscription</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8" *ngIf="subscriptionData">
                  <nb-select class="w-100" [formControl]="SubscriptionId">
                    <nb-option *ngFor="let option of subscriptionData.items" [value]="option.id">
                      {{ option.invoiceItems[0].itemDescription }}
                    </nb-option>
                  </nb-select>
                  <ngx-validation-message
                    i18n-label="@@Height"
                    label="Height"
                    [showRequired]="Height?.errors?.required && Height.touched"
                    maxLength="15"
                  ></ngx-validation-message>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div> -->
    </nb-card-body>

    <nb-card-footer *ngIf="!IsView">
      <div class="float-left">
        <button
          i18n="@@SavePatientGeneralInfo"
          nbButton
          outline
          type="submit"

          (click)="SavePatient()"
          class="btn-circle btn-xl btn-main"
          [disabled]="!PatientForm.valid || isLoading"
        >
          Save Client General Info
        </button>
      </div>
    </nb-card-footer>
  </nb-card>
</div>
